module.exports = __webpack_public_path__ + "img/liechtenstein.9b258f21.png";